import { z } from 'zod';
import { IdZ, TsZ } from './common';

/**
 * Home feed items, written by stats from bus events (game.finalized, record.broken,
 * badge.awarded, rating.updated, portrait.ready, gamelab.run.finalized, session.wrapped).
 * `kind` takes any short string so stats can add kinds; FEED_KINDS is the v1 list.
 */
export const FEED_KINDS = [
  'game_final',
  'record_broken',
  'badge',
  'milestone',
  'tier_change',
  'portrait_ready',
  'lab_result',
  'session_recap',
  'member_joined',
  'tournament_final',
  'combine_done',
] as const;

export const FeedItemZ = z.object({
  id: IdZ,
  kind: z.string().min(1).max(40),
  at: TsZ,
  playerIds: z.array(IdZ),
  refKind: z.string().max(40).nullable(),
  refId: z.string().max(80).nullable(),
  /** Already rendered line ("New crew record: 7 threes. Call the fire department."). */
  text: z.string().max(280),
  data: z.record(z.string(), z.unknown()),
});
export type FeedItem = z.infer<typeof FeedItemZ>;
